// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree-info-card {\n  margin: 5px;\n  border: none;\n}\n\n.tree-info-card-text {\n  display: block;\n  padding-bottom: 1.5rem;\n}\n\n/* removes padding for item below */\n.tree-info-card-group {\n  display: block;\n  padding-bottom: 0rem;\n}\n\n.tree-info-card-text-cite {\n  display: block;\n  padding-bottom: 1.5rem;\n  font-size: small;\n}\n", ""]);
// Exports
module.exports = exports;
